interface HourStats {
  hour: number;
  count: number;
  ampm: string;
  averageAmount: number;
}

interface TransactionsByHour {
  [merchant: string]: {
    count: number;
    totalAmount: number;
    transactions: any[];
  };
}

export const getMostFrequentShoppingHour = (transactions: any[]): HourStats => {
  // Group transactions by hour and merchant
  const hourlyTransactions = new Map<number, TransactionsByHour>();

  transactions.forEach(transaction => {
    if (transaction.amount < 0) { // Only count spending transactions
      const date = new Date(transaction.date);
      const hour = date.getHours();
      const merchant = transaction.merchant;
      const amount = Math.abs(transaction.amount);

      if (!hourlyTransactions.has(hour)) {
        hourlyTransactions.set(hour, {});
      }

      const hourData = hourlyTransactions.get(hour)!;
      if (!hourData[merchant]) {
        hourData[merchant] = {
          count: 0,
          totalAmount: 0,
          transactions: []
        };
      }

      hourData[merchant].count++;
      hourData[merchant].totalAmount += amount;
      hourData[merchant].transactions.push(transaction);
    }
  });

  let mostFrequentHour = 0;
  let maxNonRecurringCount = 0;
  let totalAmount = 0;

  // Find hour with most non-recurring transactions
  hourlyTransactions.forEach((merchants, hour) => {
    let hourCount = 0;
    let hourTotal = 0;

    Object.entries(merchants).forEach(([merchant, data]) => {
      // Skip if it looks like a recurring payment (same amount, regular intervals)
      const amounts = new Set(data.transactions.map(t => t.amount));
      const isRecurring = amounts.size === 1 && data.count > 2;
      
      if (!isRecurring) {
        hourCount += data.count;
        hourTotal += data.totalAmount;
      }
    });

    if (hourCount > maxNonRecurringCount) {
      mostFrequentHour = hour;
      maxNonRecurringCount = hourCount;
      totalAmount = hourTotal;
    }
  });

  // Convert to 12-hour format
  const ampm = mostFrequentHour >= 12 ? 'PM' : 'AM';
  const hour12 = mostFrequentHour % 12 || 12; // Convert 0 to 12 for midnight

  return {
    hour: hour12,
    count: maxNonRecurringCount,
    ampm,
    averageAmount: totalAmount / maxNonRecurringCount
  };
};
